import { render, staticRenderFns } from "./AllServices.vue?vue&type=template&id=0055b089&"
import script from "./AllServices.vue?vue&type=script&lang=js&"
export * from "./AllServices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/data/jenkins/workspace/booking-fe-stg/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0055b089')) {
      api.createRecord('0055b089', component.options)
    } else {
      api.reload('0055b089', component.options)
    }
    module.hot.accept("./AllServices.vue?vue&type=template&id=0055b089&", function () {
      api.rerender('0055b089', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Home/AllServices.vue"
export default component.exports